import React, { useEffect, useState } from 'react';
import { userApi } from '@api/user';
import { receiveAuth } from '../actions/auth';
import { useRedux } from 'use-redux';
import { Link } from 'react-router';

const ConfirmParent = props => {
  const [, dispatch] = useRedux();
  const [loading, setLoading] = useState(false);
  const {
    params: { token },
  } = props;

  useEffect(() => {
    if (token) {
      setLoading(true);
      userApi.confirmParent(token).then(res => {
        dispatch(receiveAuth(res));
        setLoading(false);
      });
    }
  }, [token, dispatch]);

  return (
    <div className="container-fluid centered-flex bg-light_green">
      <div>
        <h2>
          {loading ? 'Загрузка...' : 'Учетная запись успешно подтвержена!'}
        </h2>
        <Link to="/i">
          <button className={`btn btn-success btn-lg btn-block`}>
            На главную
          </button>
        </Link>
      </div>
    </div>
  );
};

export default ConfirmParent;
